import React from 'react';
import { useTranslation } from 'react-i18next';
import SubmittableSearchBar from '../../../../../../common-client2/src/components/SubmittableSearchBar';
import { FormControlLabel, Switch, Typography } from "@mui/material";
import './TableHeader.scss';

const TableHeader = ({isDisplaySegmentInfos, onChangeIsDisplaySegmentInfos, onChangeSearchQuery}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'billboard.listView' });
    return (
        <div className="th-root">
            <SubmittableSearchBar
                isTriggerSearchOnChange
                onChange={(searchValue) => onChangeSearchQuery(searchValue)}
            />
            <FormControlLabel
                control={<Switch
                    size="small"
                    onChange={(event, checked) => { onChangeIsDisplaySegmentInfos(checked, event) }}
                    checked={isDisplaySegmentInfos}
                    color="primary"
                />}
                label={
                    <Typography>
                        {t('showSegmentToggleLabel')}
                    </Typography>
                }
            />
        </div>
    )
}
export default TableHeader;
